import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { SelectorsService, Selector, KeyGroup } from '../../_services/selectors.service';

import { isString } from 'lodash-es';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { AsyncPipe } from '@angular/common';
import { MatOptgroup, MatOption } from '@angular/material/select';

export const _filter = (opt: Selector[], value: string): Selector[] => {
  // Filter Selectors by their label or the group name
  const filterValue = value.toLowerCase();
  return opt.filter(item => (item.label.toLowerCase().indexOf(filterValue) >= 0 || item.group.toLowerCase().indexOf(filterValue) >= 0));
};

@Component({
    selector: 'app-key-select',
    templateUrl: './key-select.component.html',
    styleUrls: ['./key-select.component.css'],
    imports: [ReactiveFormsModule, FormsModule, MatFormField, MatLabel, MatInput, MatAutocompleteTrigger, MatAutocomplete, MatOptgroup, MatOption, AsyncPipe]
})
export class KeySelectComponent implements OnInit {

  @Input() value = '';
  @Output() change: EventEmitter<string> = new EventEmitter<string>();

  keySelect = new UntypedFormControl();
  filteredKeys = this.keySelect.valueChanges.pipe(
    startWith(''),
    map((value: unknown) => this._filterGroup(value))
  );
  selectedKey: Selector;

  constructor(private ss: SelectorsService) {
    this.selectedKey = this.ss.getSelector(this.value);
  }

  ngOnInit() {
    this.selectedKey = this.ss.getSelector(this.value);
    if (!this.selectedKey.isQuestion) {
      this.keySelect.setValue(this.selectedKey);
    }
  }
  emitChange(event: MatAutocompleteSelectedEvent) {
    this.selectedKey = event.option.value;
    this.change.emit(this.selectedKey.id);
  }
  checkField(panelShowing: boolean) {
    if (this.keySelect.value !== this.selectedKey && this.keySelect.value !== '' && !panelShowing ) {
      this.keySelect.setValue('');
    }
  }

  displayFn(value: Selector | string | null): string {
    if (typeof value === 'string') {
      return value;
    }
    return value?.label ?? '';
  }

  private _filterGroup(value: unknown): KeyGroup[] {
    if (isString(value)) {
      return this.ss.groupedKeys
        .map(group => ({ section: group.section, selectors: _filter(group.selectors, value) }))
        .filter(group => group.selectors.length > 0);
    }

    return this.ss.groupedKeys;
  }
}
